import { createSlice } from "@reduxjs/toolkit";
import { IAdminSettingState } from "./adminsettingModel";
import {
  getHandlingFeesByID,
  updateHandlingFees,
} from "./services/adminsetting.services";

const initialState: IAdminSettingState = {
  loading: false,
  error: "",
  addminsettingdetails: {
    // ID: null,
    International_Cancellation_Fee: null,
    International_Conv_Fee: null,
    Domestic_Cancellation_Fee: null,
    Domestic_Conv_Fee: null,
    // IsActive: 1,
    GSTPer: null,
  },
};

const adminsettingSlice = createSlice({
  name: "adminsetting",
  initialState,
  reducers: {
    clearAdminSettingDetails: (state) => {
      state.addminsettingdetails = initialState.addminsettingdetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateHandlingFees.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateHandlingFees.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(updateHandlingFees.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getHandlingFeesByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getHandlingFeesByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.addminsettingdetails = action.payload;
    });
    builder.addCase(getHandlingFeesByID.rejected, (state, action) => {
      state.loading = false;
      state.addminsettingdetails = initialState.addminsettingdetails;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const { clearAdminSettingDetails } = adminsettingSlice.actions;
export default adminsettingSlice.reducer;
